import { GetCustomerUsersRoutine } from '../redux-routines';
import { REMOVE_USER } from '../action-types';

export const initialState = {
  data: [],
  externalUsers: [],
  error: null,
  isFetching: false,
  externalIdentifications: [],
};

export const customerUsersReducer = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case GetCustomerUsersRoutine.REQUEST:
      return {
        ...state,
        isFetching: true
      };
    case GetCustomerUsersRoutine.SUCCESS:
      return {
        ...state,
        data: action.payload.ownUsers,
        externalUsers: action.payload.externalCustomerUsers,
        externalIdentifications: action.payload.externalIdentifications,
        isFetching: false
      };
    case REMOVE_USER:
      return {
        ...state,
        data: state.data.filter(i => i.userId !== action.userId)
      };
    case GetCustomerUsersRoutine.FAILURE: {
      return {
        ...state,
        error: action.payload,
        isFetching: false,
      };
    }
    default:
      return state;
  }
};
